import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var sizeMap = {
  small: '20px',
  medium: '24px',
  large: '32px',
  inherit: 'inherit'
};
var FrejaeidIcon = function FrejaeidIcon(_ref) {
  var size = _ref.size,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'medium' : _ref$fontSize,
    className = _ref.className,
    style = _ref.style,
    role = _ref.role,
    ariaLabel = _ref['aria-label'],
    ariaHidden = _ref['aria-hidden'];
  var iconSize = size || sizeMap[fontSize];
  return (
    /*#__PURE__*/
    // This icon is an <img>, not an <svg>, so the accessibility props
    // `Icon` passes through have to be applied by hand rather than
    // spread onto an SvgIcon. `alt` is the img equivalent of the
    // `aria-label` the other icons get, so it carries the label when
    // there is one and falls back to the brand name.
    _jsx("img", {
      src: "https://www.joinflow.com/appdirectory/freja_icon.png",
      alt: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : 'Freja eID',
      role: role,
      "aria-hidden": ariaHidden,
      className: className,
      style: _objectSpread({
        width: iconSize,
        height: iconSize
      }, style)
    })
  );
};
export default FrejaeidIcon;